var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('NavFrame'),_c('v-main',{staticClass:"ma-4",staticStyle:{"padding-top":"64px"}},[_c('v-container',{attrs:{"fluid":""}},[_c('router-view')],1)],1),_c('Notifications')],1)}
var staticRenderFns = []

export { render, staticRenderFns }